import { useQuery } from "@tanstack/react-query";
import { IActivity } from "../../types";
import { getLatestActivities } from "../../services/activityService";

export const Activity = () => {
  const {
    data: activities = [],
    isLoading,
    isError,
  } = useQuery<IActivity[]>({
    queryKey: ["latestActivities"],
    queryFn: getLatestActivities,
  });

  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error loading activities!</p>;

  return (
    <div className="bg-white rounded-2xl p-4 border min-h-screen h-max">
      <h1 className="text-lg font-semibold mb-4">Recent Activity</h1>
      <div className="space-y-4 max-h-[400px]">
        {activities.length === 0 ? (
          <p className="text-gray-500 text-sm">No recent activity</p>
        ) : (
          activities.map((activity) => (
            <div
              key={activity._id}
              className="flex items-center space-x-3 p-2 bg-gray-100 rounded-lg"
            >
              <div>
                <p className="text-sm">
                  {activity.description || activity.action}
                </p>
                <span className="text-xs text-gray-500">
                  {new Date(activity.createdAt).toLocaleString()}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
